const templateUrl = require('./price.html');

const ctrl = require('./price.controller');

module.exports = angular.module('msi.products.price', [
  ctrl.module
]).name;

angular.module(module.exports)
  .component('ogProductPrice', {
    templateUrl: templateUrl,
    controller: ctrl.name,
    bindings: {
      item: '<ogFor'
    }
  });
